import create from "zustand";
import { logger } from "~features/seated-reservation/store/middleware";
import { IReleaseTicket } from "../nonseated-reservation.types";
import { TTrackingContext } from "~lib/helpers/googleAnalyticsTracking";

export type Store = {
  selectedTicketTypes: {
    [eventId: string]: IReleaseTicket[];
  };
  trackingContext: TTrackingContext;
};

const initialState: Store = {
  selectedTicketTypes: {},
  trackingContext: undefined,
};

export const useNonSeatedReservationStore = create<Store>(
  logger(
    (set, get) => ({
      ...initialState,
    }),
    "non-seated-reservation-store"
  )
);

export const getState = useNonSeatedReservationStore.getState;
export const setState = useNonSeatedReservationStore.setState;

export const resetState = () => setState(initialState, true);
